module.exports = __webpack_public_path__ + "img/22.fde3c7ad.svg";